import { CircularProgress, type CircularProgressProps } from '@mui/material';

type DangerColorCircularProgressProps = Omit<
  CircularProgressProps,
  'color' | 'size'
>;

const DangerColorCircularProgress = (
  props: DangerColorCircularProgressProps,
) => <CircularProgress color="error" size={30} {...props} />;

export default DangerColorCircularProgress;
